export default __webpack_public_path__ + "static/media/mu.dfef2128.svg";